import React, { memo } from 'react';
import { Grid } from 'gridjs-react';
import { KeyValue } from '../types/KeyValue';

type Props = {
  data: Array<KeyValue[]>;
};

const HistoryResultList: React.FC<Props> = ({ data }) => {
  return (
    <Grid
      data={data}
      columns={[
        {
          name: '更新日時',
          attributes: () => {
            return {
              style: 'width: 10px',
            };
          },
        },
        {
          name: '更新者',
          attributes: () => {
            return {
              style: 'width: 10px',
            };
          },
        },
        {
          name: '更新時状態',
          attributes: () => {
            return {
              style: 'width: 10px',
            };
          },
        },
        {
          name: '更新項目',
          attributes: () => {
            return {
              style: 'width:10px',
            };
          },
        },
        {
          name: '更新前',
          attributes: () => {
            return {
              style: 'width: 10px',
            };
          },
        },
        {
          name: '更新後',
          attributes: () => {
            return {
              style: 'width: 10px',
            };
          },
        },
      ]}
      search={false}
      sort={true}
      pagination={{
        enabled: false,
      }}
    />
  );
};

export default memo(HistoryResultList);
